// import { InternalNavLink } from '../../../components/Link/Link';
// import { HOME, } from '../../../routes/routeConstants';

export const FrequentlyAskedQuestionsData = [
 {
  title: 'What can I import to Nigeria?',
  content:
   'You can import Books, Electronics, Fashion items, Home and office appliances, Phones and tables, Health and beauty products, Sporting goods and Toys and games.',
 },
 {
  title:
   'How long does it take to ship my items from Ecommerce stores into Nigeria?',
  content:
   'Your items should have reached Nigeria approximately 3-4 days after booking is made from Chinese vendors of your choosing.',
 },
 // {
 //   title: 'How much does it cost to ship items from China to Nigeria?',
 //   content: (
 //     <>
 //       Shipping costs can be found here{' '}
 //       {
 //         <InternalNavLink
 //           to={HOME}
 //           style={{ color: 'red', fontWeight: '400' }}
 //         >
 //           [https:cmlshippingcosts.com]
 //         </InternalNavLink>
 //       }{' '}
 //     </>
 //   ),
 // },
 {
  title: 'Does CML offer door-step delivery services on last mile deliveries ?',
  content:
   'Our team offers door-step delivery services in a timely and secure fashion on  last mile deliveries.',
 },
];
